import { Type } from 'class-transformer';
import { IsDefined, IsInt, IsOptional, IsString, Length } from 'class-validator';

export class NpsSurveyQuestionUpdateDto {
  @IsDefined()
  @IsInt()
  @Type(() => Number)
  id: number;

  @IsOptional()
  @IsInt()
  @Type(() => Number)
  npsSurveyId?: number;

  @IsOptional()
  @IsString()
  @Length(1, 100)
  pieCategory?: string;

  @IsOptional()
  @IsInt()
  @Type(() => Number)
  sequence?: number;

  @IsOptional()
  @IsString()
  @Length(1, 500)
  content?: string;
}
